import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';

import Replays from 'components/UI/Replays/Replays';

const styles = theme => ({
  root: {
  },
  eventCardRoot: {
    backgroundColor: theme.palette.primary.main,
    '& .MuiTypography-h2': {
      color: '#fff',
      marginBottom: theme.spacing(2)
    },
    '& .MuiTypography-body1': {
      color: '#fff',
      textAlign: 'left',
      lineHeight: 'normal'
    },
  },
  eventCardTitleWrapper: {
    textAlign: 'left',
  },
  eventCardThemeTitle: {
    fontSize: '1rem',
    display: 'block',
    width: '100%',
  },
  eventCardThemeSubtitle: {
    width: '100%',
  },
  eventCardDescription: {
    width: '100%',
    lineHeight: 'normal',
    marginBottom: theme.spacing(4)

  },
  eventCardThemeDescription: {

  }

})
export default withStyles(styles)(Replays);



// WEBPACK FOOTER //
// ./src/components/Replays/Replays.jsx